import Protektor from '@iris-platform/protektor';
import { resolver } from '../util';
import { flattenPromise } from '../../util';
import { handleHttpErrors } from '../errors';

const allViews = resolver.authenticatedResolver.createResolver(async () => {
  const { data, error } = await flattenPromise(Protektor.allResourceNames());
  if (error) {
    return handleHttpErrors(error);
  }
  return data.map(elem => elem.resource);
});

export default {
  Query: {
    allViews,
  },
};
